var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"root",staticClass:"custom-infinite-scroll",class:{ 'custom-infinite-scroll--hidden-spinner': !_vm.spinner }},[_c('NoSSR',[(_vm.spinner)?_c(_setup.Spinner,{staticClass:"custom-infinite-scroll__spinner",attrs:{"name":"dots"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }